
export default function Services() {
  const services = [
    {
      icon: 'ri-vip-crown-line',
      title: 'VIP Rolling Services',
      description: 'Professional rolling artists with years of experience creating perfect joints for your exclusive events.',
      features: ['Expert rolling techniques', 'Premium papers & filters', 'Custom blends available', 'Discreet service']
    },
    {
      icon: 'ri-team-line',
      title: 'Professional Staff',
      description: 'Trained, discreet professionals who understand the importance of privacy and exceptional service.',
      features: ['Background checked', 'Professionally trained', 'Confidentiality assured', 'Elegant presentation']
    },
    {
      icon: 'ri-settings-3-line',
      title: 'Premium Equipment',
      description: 'State-of-the-art rolling stations and luxury accessories for the ultimate experience.',
      features: ['Luxury rolling stations', 'High-end accessories', 'Custom setup options', 'Portable solutions']
    },
    {
      icon: 'ri-calendar-event-line',
      title: 'Event Planning',
      description: 'Complete event coordination to ensure your gathering runs smoothly from start to finish.',
      features: ['Custom event packages', 'Timeline coordination', 'Setup & breakdown', 'Consultation services']
    }
  ];

  return (
    <section id="services" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h3 className="text-4xl font-bold text-gray-900 mb-4">
            Exclusive Services for Discerning Clients
          </h3>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            We provide comprehensive rolling services tailored to your specific event needs, 
            ensuring every detail meets the highest standards of quality and discretion.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {services.map((service, index) => (
            <div key={index} className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow">
              <div className="w-16 h-16 bg-emerald-100 rounded-full flex items-center justify-center mb-6">
                <i className={`${service.icon} text-2xl text-emerald-600`}></i>
              </div>
              <h4 className="text-xl font-bold text-gray-900 mb-4">{service.title}</h4>
              <p className="text-gray-600 mb-6">{service.description}</p>
              <ul className="space-y-2">
                {service.features.map((feature, featureIndex) => (
                  <li key={featureIndex} className="flex items-center text-sm text-gray-700">
                    <i className="ri-check-line text-emerald-500 mr-2"></i>
                    {feature}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
